import {findGetParameter, getCookie} from "../util/util";

// **************************************************************************************************************

const commissionParam = findGetParameter('aid')
const commissionCookie = getCookie('recommendationCode');
export const getAffiliateId = () => commissionCookie || commissionParam

const promotionParam = findGetParameter('promotion')
export const getParamPromotion = () => promotionParam

const simpleMode = findGetParameter('simple')
export const getSimpleModeFlag = () => simpleMode === "1"

const endpoint = findGetParameter('endpoint')
export const getEndpointURL = () => endpoint

const isSandboxMode = findGetParameter('sandbox')
export const getSandboxModeFlag = () => isSandboxMode

const isIgnoreGTM = findGetParameter('disablegtm')
export const isGTMDisabled = () => isIgnoreGTM

const _isContractLocked = findGetParameter('contractFixed')
export const isContractLocked = () => _isContractLocked === "1";

const redirect = findGetParameter('redirect') || ""
export const isNoRedirect = () => redirect === "false"

export const _article = findGetParameter("article");

// bestellstrecke: agenturserver projekt hinzufügen
export const _agencyServer = findGetParameter("agencyServer");

// bestellstrecken authentizierung
export const _customerNumber = findGetParameter("customerNumber");
export const _auth = findGetParameter("auth");

export const _action = findGetParameter("action")
export const _account = findGetParameter("account")
export const _contract = findGetParameter("contract")
export const _accessory = findGetParameter("accessory")
export const _preset = findGetParameter('preset')
export const _forcePartnerId = findGetParameter('forcePartnerId')

export const _initialSoftware = findGetParameter('software');

export const _orderTitle = findGetParameter('orderTitle');
export const _orderCta = findGetParameter('orderCta');

// agenturserver configurator flag
export const _useConfiguration = findGetParameter("useConfiguration");

export const _configuratorMode = findGetParameter("mode");

export const _token = findGetParameter("token");



/** WEBPACK FOOTER **
 ** ./src/selectors/GetParam.js
 **/